<template>
  <div class="column-wrapper">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ColumnWrapper'
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Elements/ColumnWrapper.vue